import { capitalizeString } from "../../utilities/helpers";

import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import Dropdown from "react-bootstrap/Dropdown";

import { EditDeleteDropdown } from "../../components/EditDeleteDropdown";

export default function SavedCard({
  card,
  user,
  selected,
  setSelected,
  selectable = false,
  openDelete,
}) {
  const content = (
    <>
      <Stack direction="horizontal" gap={3} className="flex-grow-1">
        <Stack gap={1} className="justify-content-center">
          <h5 className="normal m-0">{capitalizeString(user?.label)}</h5>
        </Stack>

        <Stack
          gap={1}
          className="flex-shrink-0 small small-bold align-items-end"
        >
          <span className="icon-text-box payment gap-2">
            {capitalizeString(card?.card?.brand)} •••• {card?.card?.last4}
          </span>
          <span className="text-muted">
            Exp {card?.card?.exp_month?.toString().padStart(2, "0")}/
            {card?.card?.exp_year}
          </span>
        </Stack>
      </Stack>

      <EditDeleteDropdown canEdit={false} canDelete={false}>
        <li className="w-100">
          <Dropdown.Item
            as="button"
            className="btn-delete"
            onClick={() => openDelete(card?.id)}
          >
            Remove card
          </Dropdown.Item>
        </li>
      </EditDeleteDropdown>
    </>
  );

  return (
    <li
      className={`list-item list-item--with-border list-item--with-border-thick list-item-lg--br list-item--white
        ${selectable ? "list-item--hover-primary list-item--hover-primary-bg-white list-item--hover-primary-border" : ""}
        ${selectable && selected === card?.id ? "selected" : ""}`}
    >
      {selectable ? (
        <Form.Check
          type="radio"
          className="form-check-display m-0"
          id={`event-display-checkbox-${card?.id}`}
        >
          <Form.Check.Input
            type="radio"
            name="event"
            value={card.id}
            checked={selected === card?.id}
            onChange={(e) => setSelected(e.target.value)}
          />

          <Form.Check.Label className="m-0 d-flex gap-3 w-100 h-100 align-items-center">
            {content}
          </Form.Check.Label>
        </Form.Check>
      ) : (
        <Stack
          direction="horizontal"
          className="justify-content-between w-100"
          gap={3}
        >
          {content}
        </Stack>
      )}
    </li>
  );
}
